// import React, { useEffect, useState } from "react";
// import AuthService from "../services/authService";
// import { getRooms } from "../services/roomService";

// export default function BookingHistory() {
//   const user = AuthService.getCurrentUser();
//   const [bookings, setBookings] = useState([]);
//   const [rooms, setRooms] = useState([]);

//   useEffect(() => {
//     const allBookings = JSON.parse(localStorage.getItem("bookings") || "[]");
//     setBookings(allBookings.filter((b) => b.userId === user.id));

//     setRooms(getRooms());
//   }, []);

//   const getRoomName = (id) => rooms.find((r) => r.id === id)?.name || "Room";

//   return (
//     <div className="p-6 max-w-2xl mx-auto">
//       <h2 className="text-2xl font-bold mb-6 text-center">My Booking History</h2>

//       {bookings.length === 0 ? (
//         <p>No bookings yet.</p>
//       ) : (
//         bookings.map((booking) => (
//           <div
//             key={booking.id}
//             className="border p-4 rounded mb-4 shadow-sm bg-white"
//           >
//             <p><strong>Room:</strong> {getRoomName(booking.roomId)}</p>
//             <p><strong>Check-in:</strong> {booking.checkIn}</p>
//             <p><strong>Check-out:</strong> {booking.checkOut}</p>
//           </div>
//         ))
//       )}
//     </div>
//   );
// }


// import React, { useEffect, useState } from "react";
// import AuthService from "../services/authService";
// import axios from "axios";

// export default function BookingHistory() {
//   const [bookings, setBookings] = useState([]);
//   const user = AuthService.getCurrentUser();

//   useEffect(() => {
//     if (!user) return;

//     axios
//       .get(`http://localhost:8080/api/booking/user/${user.id}`.trim())
//       .then((res) => setBookings(res.data))
//       .catch((err) => console.log("Error loading bookings:", err));
//   }, [user]);

//   return (
//     <div>
//       <h2>My Bookings</h2>

//       {bookings.length === 0 ? (
//         <p>No bookings found.</p>
//       ) : (
//         bookings.map((b) => (
//           <div key={b.id} style={{ border: "1px solid black", margin: "10px", padding: "10px" }}>
//             <h3>{b.roomName ||b.roomType}</h3>
//             <p><strong>Check-in:</strong> {b.checkIn}</p>
//             <p><strong>Check-out:</strong> {b.checkOut}</p>
//             <p><strong>Total Price:</strong> ₹{b.totalPrice}</p>
//           </div>
//         ))
//       )}
//     </div>
//   );
// }



// import React, { useEffect, useState } from "react";
// import AuthService from "../services/authService";
// import axios from "axios";

// function formatDate(d) {
//   if (!d) return "";
//   // backend returns "YYYY-MM-DD" string — show nicely
//   const dt = new Date(d);
//   return dt.toLocaleDateString();
// }

// export default function BookingHistory() {
//   const [bookings, setBookings] = useState([]);
//   const user = AuthService.getCurrentUser();

//   useEffect(() => {
//     if (!user) return;

//     axios
//       .get(`http://localhost:8080/api/booking/user/${user.id}`)
//       .then((res) => setBookings(res.data))
//       .catch((err) => console.log("Error loading bookings:", err));
//   }, [user]);

//   return (
//     <div style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
//       <h2>My Bookings</h2>

//       {bookings.length === 0 ? (
//         <p>No bookings found.</p>
//       ) : (
//         bookings.map((b) => (
//           <div
//             key={b.bookingId}
//             style={{
//               border: "1px solid #ddd",
//               borderRadius: 8,
//               margin: "12px 0",
//               padding: 12,
//               display: "flex",
//               gap: 12,
//               alignItems: "center",
//             }}
//           >
            


//             <div style={{ width: 140, height: 100, overflow: "hidden", borderRadius: 8 }}>
//        <img
//   src={
//     !b.roomImage
//       ? "/default.jpg"
//       : b.roomImage.startsWith("data:")
//       ? b.roomImage
//       : `/${b.roomImage}`  // --> for "rooms/deluxe1.jpg"
//   }
//   alt="room"
//   style={{ width: "200px", height: "150px", objectFit: "cover" }}
// />
//  </div>


//             <div style={{ flex: 1 }}>
//               <h3 style={{ margin: 0 }}>
//                 {b.roomName ? b.roomName : b.roomType}
//               </h3>
//               <p style={{ margin: "6px 0" }}>
//                 <strong>Type:</strong> {b.roomType || "—"}{" "}
//                 {b.capacity ? `• Capacity: ${b.capacity} persons` : ""}
//               </p>

//               <p style={{ margin: "6px 0" }}>
//                 <strong>Check-in:</strong> {formatDate(b.checkIn)}{" "}
//                 <strong style={{ marginLeft: 12 }}>Check-out:</strong> {formatDate(b.checkOut)}
//               </p>

//               <p style={{ margin: "6px 0" }}>
//                 <strong>Total Price:</strong> ₹{b.totalPrice?.toFixed(2) ?? "0.00"}
//               </p>

//               <p style={{ margin: "6px 0", color: "#666" }}>
//                 {/* <small>Status: {b.status ?? "CONFIRMED"}</small> */}
//               <small> Status:
//                 {b.status === "PENDING" && " ⏳ Pending"}
//                 {b.status === "CONFIRMED" && " ✅ Confirmed"}
//                 {b.status === "REJECTED" && " ❌ Rejected"}
//               </small>     
//               </p>
//         </div>
//           </div>
//         ))
//       )}
//     </div>
//   );
// }

//****Admin Approval Code 6/1/26***** //

import React, { useEffect, useState } from "react";
import AuthService from "../services/authService";
import axios from "axios";

function formatDate(d) {
  if (!d) return "";
  const dt = new Date(d);
  return dt.toLocaleDateString();
}

export default function BookingHistory() {
  const [bookings, setBookings] = useState([]);
  const user = AuthService.getCurrentUser();

  useEffect(() => {
    if (!user) return;

    axios
      .get(`http://localhost:8080/api/booking/user/${user.id}`)
      .then((res) => setBookings(res.data))
      .catch((err) => console.log("Error loading bookings:", err));
  }, [user]);

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h2>My Bookings</h2>

      {bookings.length === 0 ? (
        <p>No bookings found.</p>
      ) : (
        bookings.map((b) => (
          <div
            key={b.bookingId}
            style={{
              border: "1px solid #ddd",
              borderRadius: 8,
              margin: "12px 0",
              padding: 12,
              display: "flex",
              gap: 12,
              alignItems: "center",
            }}
          >
            {/* ROOM IMAGE */}
            <div
              style={{
                width: 140,
                height: 100,
                overflow: "hidden",
                borderRadius: 8,
              }}
            >
              <img
                src={
                  !b.roomImage
                    ? "/default.jpg"
                    : b.roomImage.startsWith("data:")
                    ? b.roomImage
                    : `http://localhost:8080/${b.roomImage}`
                }
                alt="room"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* BOOKING DETAILS */}
            <div style={{ flex: 1 }}>
              <h3 style={{ margin: 0 }}>
                {b.roomName || "Room"}
              </h3>

              <p style={{ margin: "6px 0" }}>
                <strong>Type:</strong> {b.roomType || "—"}{" "}
                {b.capacity ? `• Capacity: ${b.capacity} persons` : ""}
              </p>

              <p style={{ margin: "6px 0" }}>
                <strong>Check-in:</strong> {formatDate(b.checkIn)}
                <strong style={{ marginLeft: 12 }}>Check-out:</strong>{" "}
                {formatDate(b.checkOut)}
              </p>

              <p style={{ margin: "6px 0" }}>
                <strong>Total Price:</strong> ₹
                {b.totalPrice ? b.totalPrice.toFixed(2) : "0.00"}
              </p>

              {/* STATUS */}
              <p style={{ margin: "6px 0" }}>
                <strong>Status:</strong>{" "}
                {b.status === "PENDING" && (
                  <span style={{ color: "#f0ad4e" }}>⏳ Pending</span>
                )}
                {b.status === "CONFIRMED" && (
                  <span style={{ color: "#5cb85c" }}>✅ Confirmed</span>
                )}
                {b.status === "REJECTED" && (
                  <span style={{ color: "#d9534f" }}>❌ Rejected</span>
                )}
              </p>

              {/* ADMIN MESSAGE (OPTIONAL BUT RECOMMENDED) */}
              {b.adminMessage && (
                <p style={{ margin: "6px 0", color: "#666" }}>
                  <em>{b.adminMessage}</em>
                </p>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
